(function () {
  var IDENTIFIER_PATTERN = /[^A-Z0-9]/g;
  var WORD_PATTERN = /[a-z0-9]+/g;
  var WEIGHT_NUMBER_SOURCE = '\\d+(?:\\.\\d+)?';
  var WEIGHT_POUND_UNIT_SOURCE = '(?:lb|lbs|pound|pounds|#)';
  var WEIGHT_OUNCE_UNIT_SOURCE = '(?:oz|ounce|ounces)';
  var WEIGHT_AMOUNT_SOURCE = '(?:' + WEIGHT_NUMBER_SOURCE + '\\s*' + WEIGHT_POUND_UNIT_SOURCE + '(?:\\s*' + WEIGHT_NUMBER_SOURCE + '\\s*' + WEIGHT_OUNCE_UNIT_SOURCE + ')?|' + WEIGHT_NUMBER_SOURCE + '\\s*' + WEIGHT_OUNCE_UNIT_SOURCE + ')';
  var NUT_WIDTH_EXACT_TOLERANCE_INCHES = 0.01;
  var NUT_WIDTH_NUMBER_SOURCE = '\\d+(?:\\.\\d+)?';
  var NUT_WIDTH_INCH_UNIT_SOURCE = '(?:in|inch|inches|"|\\u201c|\\u201d)';
  var NUT_WIDTH_MILLIMETER_UNIT_SOURCE = '(?:mm|millimeter|millimeters)';
  var NUT_WIDTH_AMOUNT_SOURCE = '(?:\\d+(?:\\s+|-)\\d+\\/\\d+|\\d+\\/\\d+|' + NUT_WIDTH_NUMBER_SOURCE + '\\s*' + NUT_WIDTH_MILLIMETER_UNIT_SOURCE + '|' + NUT_WIDTH_NUMBER_SOURCE + '\\s*' + NUT_WIDTH_INCH_UNIT_SOURCE + '|' + NUT_WIDTH_NUMBER_SOURCE + ')';
  var CORE_ALIASES = {
    r8: [['1958'], ['les'], ['paul'], ['standard']],
    r9: [['1959'], ['les'], ['paul'], ['standard']],
    r0: [['1960'], ['les'], ['paul'], ['standard']],
    lp: [['les'], ['paul']],
    strat: [['strat', 'stratocaster']],
    tele: [['tele', 'telecaster']],
    prs: [['prs', 'paul reed smith']],
    'custom shop': [['custom'], ['shop']],
  };

  function normalizeIdentifierKey(value) {
    return String(value || '').trim().toUpperCase().replace(IDENTIFIER_PATTERN, '');
  }

  function normalizeText(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function cleanDisplayText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function roundOunces(value) {
    return Math.round(value * 1000) / 1000;
  }

  function roundInches(value) {
    return Math.round(value * 1000000) / 1000000;
  }

  function roundNutWidthSearchCenter(value) {
    return Math.round(value * 100) / 100;
  }

  function finiteNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function parseWeightAmount(value) {
    var display = cleanDisplayText(value);
    var poundPattern = new RegExp('^(' + WEIGHT_NUMBER_SOURCE + ')\\s*' + WEIGHT_POUND_UNIT_SOURCE + '(?:\\s*(' + WEIGHT_NUMBER_SOURCE + ')\\s*' + WEIGHT_OUNCE_UNIT_SOURCE + ')?$', 'i');
    var ouncePattern = new RegExp('^(' + WEIGHT_NUMBER_SOURCE + ')\\s*' + WEIGHT_OUNCE_UNIT_SOURCE + '$', 'i');
    var poundMatch = display.match(poundPattern);
    var ounces;
    var pounds;
    var ounceMatch;

    if (poundMatch) {
      pounds = finiteNumber(poundMatch[1]);
      ounces = finiteNumber(poundMatch[2] || '0');
      if (pounds == null || ounces == null) return null;
      return {
        display: display,
        ounces: roundOunces((pounds * 16) + ounces),
      };
    }

    ounceMatch = display.match(ouncePattern);
    if (ounceMatch) {
      ounces = finiteNumber(ounceMatch[1]);
      if (ounces == null) return null;
      return {
        display: display,
        ounces: roundOunces(ounces),
      };
    }

    return null;
  }

  function parseNutWidthAmount(value) {
    var display = cleanDisplayText(value);
    var parseDisplay = display.replace(/[\u201c\u201d]/g, '"');
    var inchUnit = '(?:in|inch|inches|")';
    var millimeterUnit = '(?:mm|millimeter|millimeters)';
    var mixedFractionPattern = new RegExp('^(\\d+)(?:\\s+|-)(\\d+)\\/(\\d+)(?:\\s*' + inchUnit + ')?$', 'i');
    var fractionPattern = new RegExp('^(\\d+)\\/(\\d+)(?:\\s*' + inchUnit + ')?$', 'i');
    var millimeterPattern = new RegExp('^(' + NUT_WIDTH_NUMBER_SOURCE + ')\\s*' + millimeterUnit + '$', 'i');
    var decimalPattern = new RegExp('^(' + NUT_WIDTH_NUMBER_SOURCE + ')(?:\\s*' + inchUnit + ')?$', 'i');
    var match;
    var whole;
    var numerator;
    var denominator;
    var number;

    match = parseDisplay.match(mixedFractionPattern);
    if (match) {
      whole = finiteNumber(match[1]);
      numerator = finiteNumber(match[2]);
      denominator = finiteNumber(match[3]);
      if (whole == null || numerator == null || denominator == null || denominator === 0) return null;
      return {
        display: display,
        inches: roundInches(whole + (numerator / denominator)),
      };
    }

    match = parseDisplay.match(fractionPattern);
    if (match) {
      numerator = finiteNumber(match[1]);
      denominator = finiteNumber(match[2]);
      if (numerator == null || denominator == null || denominator === 0) return null;
      return {
        display: display,
        inches: roundInches(numerator / denominator),
      };
    }

    match = parseDisplay.match(millimeterPattern);
    if (match) {
      number = finiteNumber(match[1]);
      if (number == null) return null;
      return {
        display: display,
        inches: number / 25.4,
      };
    }

    match = parseDisplay.match(decimalPattern);
    if (match) {
      number = finiteNumber(match[1]);
      if (number == null) return null;
      return {
        display: display,
        inches: roundInches(number),
      };
    }

    return null;
  }

  function applyWeightMinimum(filter, amount) {
    if (!amount) return;
    if (filter.minOunces == null || amount.ounces > filter.minOunces) {
      filter.minOunces = amount.ounces;
      filter.minDisplay = amount.display;
    }
  }

  function applyWeightMaximum(filter, amount) {
    if (!amount) return;
    if (filter.maxOunces == null || amount.ounces < filter.maxOunces) {
      filter.maxOunces = amount.ounces;
      filter.maxDisplay = amount.display;
    }
  }

  function weightFilterLabel(filter) {
    if (filter.minOunces != null && filter.maxOunces != null) {
      return 'between ' + filter.minDisplay + ' and ' + filter.maxDisplay;
    }
    if (filter.maxOunces != null) {
      return 'at or below ' + filter.maxDisplay;
    }
    if (filter.minOunces != null) {
      return 'at or above ' + filter.minDisplay;
    }
    return '';
  }

  function applyNutWidthMinimum(filter, amount) {
    if (!amount) return;
    if (filter.minInches == null || amount.inches > filter.minInches) {
      filter.minInches = amount.inches;
      filter.minDisplay = amount.display;
    }
  }

  function applyNutWidthMaximum(filter, amount) {
    if (!amount) return;
    if (filter.maxInches == null || amount.inches < filter.maxInches) {
      filter.maxInches = amount.inches;
      filter.maxDisplay = amount.display;
    }
  }

  function applyNutWidthExact(filter, amount) {
    var center;
    if (!amount) return;
    center = roundNutWidthSearchCenter(amount.inches);
    applyNutWidthMinimum(filter, {
      display: amount.display,
      inches: roundInches(center - NUT_WIDTH_EXACT_TOLERANCE_INCHES),
    });
    applyNutWidthMaximum(filter, {
      display: amount.display,
      inches: roundInches(center + NUT_WIDTH_EXACT_TOLERANCE_INCHES),
    });
    filter.exactDisplay = amount.display;
  }

  function nutWidthFilterLabel(filter) {
    if (filter.exactDisplay) {
      return 'near nut width ' + filter.exactDisplay;
    }
    if (filter.minInches != null && filter.maxInches != null) {
      return 'with nut width between ' + filter.minDisplay + ' and ' + filter.maxDisplay;
    }
    if (filter.maxInches != null) {
      return 'with nut width at or below ' + filter.maxDisplay;
    }
    if (filter.minInches != null) {
      return 'with nut width at or above ' + filter.minDisplay;
    }
    return '';
  }

  function addRemovalRange(ranges, index, length) {
    ranges.push({
      start: index,
      end: index + length,
    });
  }

  function rangeOverlaps(ranges, start, end) {
    for (var i = 0; i < ranges.length; i += 1) {
      if (start < ranges[i].end && end > ranges[i].start) return true;
    }
    return false;
  }

  function removeQueryRanges(query, ranges) {
    var output = String(query || '');
    ranges
      .slice()
      .sort(function (a, b) {
        return b.start - a.start;
      })
      .forEach(function (range) {
        output = output.slice(0, range.start) + ' ' + output.slice(range.end);
      });

    return output.replace(/\s+/g, ' ').trim();
  }

  function findWeightPatternMatches(query, pattern, callback, removals) {
    var match;
    var start;
    var end;
    pattern.lastIndex = 0;
    while ((match = pattern.exec(query)) !== null) {
      start = match.index;
      end = match.index + match[0].length;
      if (rangeOverlaps(removals, start, end)) continue;
      callback(match);
      addRemovalRange(removals, start, match[0].length);
    }
  }

  function parseWeightFilteredQuery(query) {
    var rawQuery = String(query || '');
    var filter = {
      minOunces: null,
      maxOunces: null,
      minDisplay: '',
      maxDisplay: '',
    };
    var removals = [];
    var betweenPattern = new RegExp('\\bbetween\\s+(' + WEIGHT_AMOUNT_SOURCE + ')\\s+(?:and|to|-)\\s+(' + WEIGHT_AMOUNT_SOURCE + ')', 'gi');
    var rangePattern = new RegExp('(^|\\s)(' + WEIGHT_AMOUNT_SOURCE + ')\\s*(?:-|to)\\s*(' + WEIGHT_AMOUNT_SOURCE + ')', 'gi');
    var maxPrefixPattern = new RegExp('\\b(?:under|below|less\\s+than)\\s+(' + WEIGHT_AMOUNT_SOURCE + ')', 'gi');
    var maxSuffixPattern = new RegExp('(^|\\s)(' + WEIGHT_AMOUNT_SOURCE + ')\\s+or\\s+less\\b', 'gi');
    var minPrefixPattern = new RegExp('\\b(?:over|above|more\\s+than)\\s+(' + WEIGHT_AMOUNT_SOURCE + ')', 'gi');
    var minSuffixPattern = new RegExp('(^|\\s)(' + WEIGHT_AMOUNT_SOURCE + ')\\s+or\\s+more\\b', 'gi');
    var hasFilter = false;

    findWeightPatternMatches(rawQuery, betweenPattern, function (match) {
      applyWeightMinimum(filter, parseWeightAmount(match[1]));
      applyWeightMaximum(filter, parseWeightAmount(match[2]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, rangePattern, function (match) {
      applyWeightMinimum(filter, parseWeightAmount(match[2]));
      applyWeightMaximum(filter, parseWeightAmount(match[3]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, maxPrefixPattern, function (match) {
      applyWeightMaximum(filter, parseWeightAmount(match[1]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, maxSuffixPattern, function (match) {
      applyWeightMaximum(filter, parseWeightAmount(match[2]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, minPrefixPattern, function (match) {
      applyWeightMinimum(filter, parseWeightAmount(match[1]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, minSuffixPattern, function (match) {
      applyWeightMinimum(filter, parseWeightAmount(match[2]));
      hasFilter = true;
    }, removals);

    if (!hasFilter) {
      return {
        textQuery: rawQuery.trim(),
        weightFilter: null,
      };
    }

    return {
      textQuery: removeQueryRanges(rawQuery, removals),
      weightFilter: {
        minOunces: filter.minOunces,
        maxOunces: filter.maxOunces,
        label: weightFilterLabel(filter),
      },
    };
  }

  function stripStandaloneWeightKeyword(query) {
    var rawQuery = String(query || '');
    var found = /\bweight\b/i.test(rawQuery);
    return {
      found: found,
      textQuery: found ? rawQuery.replace(/\bweight\b/gi, ' ').replace(/\s+/g, ' ').trim() : rawQuery.trim(),
    };
  }

  function parseNutWidthFilteredQuery(query) {
    var rawQuery = String(query || '');
    var filter = {
      minInches: null,
      maxInches: null,
      minDisplay: '',
      maxDisplay: '',
      exactDisplay: '',
    };
    var removals = [];
    var nutPrefix = 'nut(?:\\s+width)?';
    var betweenPrefixPattern = new RegExp('\\b' + nutPrefix + '\\s+between\\s+(' + NUT_WIDTH_AMOUNT_SOURCE + ')\\s+(?:and|to|-)\\s+(' + NUT_WIDTH_AMOUNT_SOURCE + ')', 'gi');
    var rangePrefixPattern = new RegExp('\\b' + nutPrefix + '\\s+(' + NUT_WIDTH_AMOUNT_SOURCE + ')\\s*(?:-|to)\\s*(' + NUT_WIDTH_AMOUNT_SOURCE + ')', 'gi');
    var maxPrefixPattern = new RegExp('\\b' + nutPrefix + '\\s+(?:under|below|less\\s+than)\\s+(' + NUT_WIDTH_AMOUNT_SOURCE + ')', 'gi');
    var maxSuffixPattern = new RegExp('\\b(?:under|below|less\\s+than)\\s+(' + NUT_WIDTH_AMOUNT_SOURCE + ')\\s+' + nutPrefix + '\\b', 'gi');
    var maxOrLessPattern = new RegExp('\\b' + nutPrefix + '\\s+(' + NUT_WIDTH_AMOUNT_SOURCE + ')\\s+or\\s+less\\b', 'gi');
    var minPrefixPattern = new RegExp('\\b' + nutPrefix + '\\s+(?:over|above|more\\s+than)\\s+(' + NUT_WIDTH_AMOUNT_SOURCE + ')', 'gi');
    var minSuffixPattern = new RegExp('\\b(?:over|above|more\\s+than)\\s+(' + NUT_WIDTH_AMOUNT_SOURCE + ')\\s+' + nutPrefix + '\\b', 'gi');
    var minOrMorePattern = new RegExp('\\b' + nutPrefix + '\\s+(' + NUT_WIDTH_AMOUNT_SOURCE + ')\\s+or\\s+more\\b', 'gi');
    var exactPrefixPattern = new RegExp('\\b' + nutPrefix + '\\s+(' + NUT_WIDTH_AMOUNT_SOURCE + ')', 'gi');
    var exactSuffixPattern = new RegExp('(^|\\s)(' + NUT_WIDTH_AMOUNT_SOURCE + ')\\s+' + nutPrefix + '\\b', 'gi');
    var keywordPattern = /\bnut\s+width\b/gi;
    var hasFilter = false;
    var requiresNutWidth = false;

    findWeightPatternMatches(rawQuery, betweenPrefixPattern, function (match) {
      applyNutWidthMinimum(filter, parseNutWidthAmount(match[1]));
      applyNutWidthMaximum(filter, parseNutWidthAmount(match[2]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, rangePrefixPattern, function (match) {
      applyNutWidthMinimum(filter, parseNutWidthAmount(match[1]));
      applyNutWidthMaximum(filter, parseNutWidthAmount(match[2]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, maxPrefixPattern, function (match) {
      applyNutWidthMaximum(filter, parseNutWidthAmount(match[1]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, maxSuffixPattern, function (match) {
      applyNutWidthMaximum(filter, parseNutWidthAmount(match[1]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, maxOrLessPattern, function (match) {
      applyNutWidthMaximum(filter, parseNutWidthAmount(match[1]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, minPrefixPattern, function (match) {
      applyNutWidthMinimum(filter, parseNutWidthAmount(match[1]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, minSuffixPattern, function (match) {
      applyNutWidthMinimum(filter, parseNutWidthAmount(match[1]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, minOrMorePattern, function (match) {
      applyNutWidthMinimum(filter, parseNutWidthAmount(match[1]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, exactPrefixPattern, function (match) {
      applyNutWidthExact(filter, parseNutWidthAmount(match[1]));
      hasFilter = true;
    }, removals);

    findWeightPatternMatches(rawQuery, exactSuffixPattern, function (match) {
      applyNutWidthExact(filter, parseNutWidthAmount(match[2]));
      hasFilter = true;
    }, removals);

    if (!hasFilter) {
      findWeightPatternMatches(rawQuery, keywordPattern, function () {
        requiresNutWidth = true;
      }, removals);
    }

    return {
      textQuery: hasFilter || requiresNutWidth ? removeQueryRanges(rawQuery, removals) : rawQuery.trim(),
      nutWidthFilter: hasFilter
        ? {
            minInches: filter.minInches,
            maxInches: filter.maxInches,
            label: nutWidthFilterLabel(filter),
          }
        : null,
      nutWidthRequired: requiresNutWidth,
    };
  }

  function parseSpecFilteredQuery(query) {
    var weightParsed = parseWeightFilteredQuery(query);
    var weightKeyword = stripStandaloneWeightKeyword(weightParsed.textQuery);
    var nutWidthParsed = parseNutWidthFilteredQuery(weightKeyword.textQuery);
    var labels = [];
    var weightActive = Boolean(weightParsed.weightFilter) || weightKeyword.found;
    var nutWidthActive = Boolean(nutWidthParsed.nutWidthFilter) || nutWidthParsed.nutWidthRequired;

    if (weightParsed.weightFilter && weightParsed.weightFilter.label) {
      labels.push(weightParsed.weightFilter.label);
    } else if (weightKeyword.found) {
      labels.push('with Guitar Weight');
    }

    if (nutWidthParsed.nutWidthFilter && nutWidthParsed.nutWidthFilter.label) {
      labels.push(nutWidthParsed.nutWidthFilter.label);
    } else if (nutWidthParsed.nutWidthRequired) {
      labels.push('with Nut Width');
    }

    return {
      textQuery: nutWidthParsed.textQuery,
      weightFilter: weightParsed.weightFilter,
      weightRequired: weightKeyword.found && !weightParsed.weightFilter,
      nutWidthFilter: nutWidthParsed.nutWidthFilter,
      nutWidthRequired: nutWidthParsed.nutWidthRequired,
      displaySpecs: {
        weight: weightActive,
        nutWidth: nutWidthActive,
      },
      labels: labels,
    };
  }

  function words(value) {
    return normalizeText(value).match(WORD_PATTERN) || [];
  }

  function entryHaystack(entry) {
    return normalizeText([
      entry.title,
      entry.vendor,
      entry.product_type,
      entry.handle,
      entry.variant_title,
      entry.serial_number,
      entry.reference_number,
      entry.search_text,
      Array.isArray(entry.tags) ? entry.tags.join(' ') : '',
    ].join(' '));
  }

  function titleHaystack(entry) {
    return normalizeText([entry.title, entry.vendor].join(' '));
  }

  function expandQueryGroups(query) {
    var normalized = normalizeText(query);
    if (!normalized) return [];

    if (CORE_ALIASES[normalized]) {
      return CORE_ALIASES[normalized];
    }

    var queryWords = words(query);
    var groups = [];
    for (var i = 0; i < queryWords.length; i += 1) {
      var word = queryWords[i];
      if (CORE_ALIASES[word]) {
        groups = groups.concat(CORE_ALIASES[word]);
      } else {
        groups.push([word]);
      }
    }
    return groups;
  }

  function groupMatches(haystack, group) {
    for (var i = 0; i < group.length; i += 1) {
      var alternative = normalizeText(group[i]);
      if (alternative && haystack.indexOf(alternative) !== -1) return true;
    }
    return false;
  }

  function allGroupsMatch(haystack, groups) {
    if (!groups.length) return false;
    for (var i = 0; i < groups.length; i += 1) {
      if (!groupMatches(haystack, groups[i])) return false;
    }
    return true;
  }

  function isExactIdentifierMatch(entry, query) {
    var key = normalizeIdentifierKey(query);
    if (!key) return false;
    return Boolean(
      (entry.reference_key && entry.reference_key === key) ||
      (entry.serial_key && entry.serial_key === key) ||
      (entry.sku_key && entry.sku_key === key)
    );
  }

  function scoreEntry(entry, query) {
    var normalizedQuery = normalizeText(query);
    var haystack = entryHaystack(entry);
    var title = titleHaystack(entry);
    var groups = expandQueryGroups(query);
    var score = 0;

    if (isExactIdentifierMatch(entry, query)) {
      score += 10000;
    } else if (!allGroupsMatch(haystack, groups)) {
      return 0;
    }

    if (normalizedQuery && title.indexOf(normalizedQuery) !== -1) score += 5000;
    if (normalizedQuery && haystack.indexOf(normalizedQuery) !== -1) score += 2000;
    if (allGroupsMatch(title, groups)) score += 1500;
    score += groups.length * 100;
    if (entry.entry_type === 'guitar_listing') score += 50;
    if (entry.available) score += 25;

    return score;
  }

  function compareRanked(a, b) {
    return (
      b._score - a._score ||
      Number(Boolean(b.available)) - Number(Boolean(a.available)) ||
      String(a.title || '').localeCompare(String(b.title || '')) ||
      String(a.variant_title || '').localeCompare(String(b.variant_title || '')) ||
      String(a.url || '').localeCompare(String(b.url || ''))
    );
  }

  function entryMatchesWeightFilter(entry, filter) {
    var ounces;
    if (!filter) return true;
    if (!entry || entry.entry_type !== 'guitar_listing') return false;

    ounces = finiteNumber(entry.weight_ounces);
    if (ounces == null) return false;
    if (filter.minOunces != null && ounces < filter.minOunces) return false;
    if (filter.maxOunces != null && ounces > filter.maxOunces) return false;
    return true;
  }

  function entryMatchesNutWidthFilter(entry, filter) {
    var inches;
    if (!filter) return true;
    if (!entry || entry.entry_type !== 'guitar_listing') return false;

    inches = finiteNumber(entry.nut_width_inches);
    if (inches == null) return false;
    if (filter.minInches != null && inches < filter.minInches) return false;
    if (filter.maxInches != null && inches > filter.maxInches) return false;
    return true;
  }

  function entryHasWeight(entry) {
    return Boolean(entry && entry.entry_type === 'guitar_listing' && finiteNumber(entry.weight_ounces) != null);
  }

  function entryHasNutWidth(entry) {
    return Boolean(entry && entry.entry_type === 'guitar_listing' && finiteNumber(entry.nut_width_inches) != null);
  }

  function entryMatchesSpecIntent(entry, parsedQuery) {
    if (!parsedQuery) return true;
    if ((parsedQuery.weightFilter || parsedQuery.weightRequired) && !entryHasWeight(entry)) return false;
    if (!entryMatchesWeightFilter(entry, parsedQuery.weightFilter)) return false;
    if ((parsedQuery.nutWidthFilter || parsedQuery.nutWidthRequired) && !entryHasNutWidth(entry)) return false;
    if (!entryMatchesNutWidthFilter(entry, parsedQuery.nutWidthFilter)) return false;
    return true;
  }

  function hasSpecIntent(parsedQuery) {
    return Boolean(parsedQuery && parsedQuery.displaySpecs && (parsedQuery.displaySpecs.weight || parsedQuery.displaySpecs.nutWidth));
  }

  function compareWeightFilteredOnly(a, b) {
    return (
      Number(Boolean(b.available)) - Number(Boolean(a.available)) ||
      a._index - b._index
    );
  }

  function rankSearchEntries(entries, query, options) {
    var limit = options && options.limit ? options.limit : 50;
    var parsedQuery = parseSpecFilteredQuery(query);
    var specIntent = hasSpecIntent(parsedQuery);
    var queryForText = specIntent ? parsedQuery.textQuery : query;
    var specFilteredEntries = specIntent
      ? (entries || []).filter(function (entry) {
          return entryMatchesSpecIntent(entry, parsedQuery);
        })
      : (entries || []);

    if (specIntent && !normalizeText(queryForText)) {
      return specFilteredEntries
        .map(function (entry, index) {
          return Object.assign({}, entry, { _score: 0, _index: index });
        })
        .sort(compareWeightFilteredOnly)
        .slice(0, limit)
        .map(function (entry) {
          delete entry._index;
          return entry;
        });
    }

    return specFilteredEntries
      .map(function (entry) {
        var score = scoreEntry(entry, queryForText);
        if (!score) return null;
        return Object.assign({}, entry, { _score: score });
      })
      .filter(Boolean)
      .sort(compareRanked)
      .slice(0, limit);
  }

  function findExactIdentifierMatches(entries, query) {
    return (entries || [])
      .filter(function (entry) {
        return isExactIdentifierMatch(entry, query);
      })
      .sort(compareRanked);
  }

  function compareVariantSkuLookupEntries(a, b) {
    return (
      Number(Boolean(b.available)) - Number(Boolean(a.available)) ||
      String(a.product_title || '').localeCompare(String(b.product_title || '')) ||
      String(a.variant_title || '').localeCompare(String(b.variant_title || '')) ||
      String(a.variant_id || '').localeCompare(String(b.variant_id || '')) ||
      String(a.url || '').localeCompare(String(b.url || ''))
    );
  }

  function findExactVariantSkuLookupMatches(lookups, query) {
    var key = normalizeIdentifierKey(query);
    if (!key) return [];

    return (lookups || [])
      .filter(function (entry) {
        return entry && entry.key === key;
      })
      .sort(compareVariantSkuLookupEntries);
  }

  window.RGSearchCore = {
    normalizeIdentifierKey: normalizeIdentifierKey,
    parseWeightFilteredQuery: parseWeightFilteredQuery,
    parseSpecFilteredQuery: parseSpecFilteredQuery,
    rankSearchEntries: rankSearchEntries,
    findExactIdentifierMatches: findExactIdentifierMatches,
    findExactVariantSkuLookupMatches: findExactVariantSkuLookupMatches,
  };
})();
